import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import Bezier from 'bezier-easing';
export function easing(a, b, c, d) {
  var r = Bezier(a, b, c, d);

  r.toString = function () {
    var _context, _context2, _context3;

    return _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "cubic-bezier(".concat(a, ",")).call(_context3, b, ",")).call(_context2, c, ",")).call(_context, d, ")");
  };

  return r;
}